import React from 'react';
import { connect } from 'react-redux'

const Players = (props) => {
  return (
    <div className='u-flex'>
      <div className={`Player u-margin ${props.activePlayer === 'X' ? 'u-active' : null}`}>Player 1(X)</div>
      <div className={`Player u-margin ${props.activePlayer === 'O' ? 'u-active' : null}`}>Player 2(O)</div>
    </div>
  )

};

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    activePlayer: state.activePlayer
  }
}


export default connect(mapStateToProps)(Players);